import React from 'react';
import PropTypes from 'prop-types';

import PricingStatusBadge from 'features/ManageServices/Components/ServicePricingSection/PricingStatusBadge/PricingStatusBadge';

import messages from '../ClassesList.messages';
import { getBookableStatusDisplay } from '../ClassesList.helpers';

const BookableStatus = ({ venueClass }) => {
  const { classId, disabled, retailRateRequest, classPricingRule } = venueClass;
  const { messageKey, iconType, tooltipMessageKey } = getBookableStatusDisplay({
    disabled,
    retailRateRequest,
    hasPrice: !!classPricingRule,
  });

  return (
    <PricingStatusBadge
      iconType={iconType}
      messageKey={messageKey}
      messages={messages}
      tooltipMessageKey={tooltipMessageKey}
      tooltipName={`bookable-status-tooltip-${classId}`}
    />
  );
};

BookableStatus.propTypes = {
  venueClass: PropTypes.shape({
    classId: PropTypes.number,
    disabled: PropTypes.bool,
    retailRateRequest: PropTypes.shape({
      status: PropTypes.string,
      statusReason: PropTypes.string,
    }),
    classPricingRule: PropTypes.shape({}),
  }),
};

export default BookableStatus;
